import React from 'react';
import { Link } from '../Link.jsx';
import AuthorizedAction from '../AuthorizedAction.js';
import { getOrgSlug } from '../../lib/utils.js';

export const InitiativesLink = ({ projectId, ...props }) => {
  return (
    <Link
      route="projects/initiatives/show"
      params={{ projectId, slug: getOrgSlug() }}
      {...props}
    />
  );
};

export const InitiativeLink = ({
  initiative,
  initiativeParticipationId,
  stakeholderParticipationId,
  scroll,
  ...props
}) => {
  const params = {
    initiativeId: initiative.id,
    initiativeType: initiative.type,
    slug: getOrgSlug(),
  };

  if (initiativeParticipationId) {
    params.participant = initiativeParticipationId;
  }
  if (stakeholderParticipationId) {
    params.stakeholder = stakeholderParticipationId;
  }

  return (
    <Link route="initiatives/show" params={params} scroll={scroll} {...props} />
  );
};

export const InitiativePreviewLink = ({
  initiative,
  initiativeParticipationId,
  stakeholderParticipationId,
  ...props
}) => {
  const params = {
    initiativeId: initiative.id,
    initiativeType: initiative.type,
    slug: getOrgSlug(),
  };

  if (initiativeParticipationId) {
    params.participant = initiativeParticipationId;
  }
  if (stakeholderParticipationId) {
    params.stakeholder = stakeholderParticipationId;
  }
  return (
    <Link
      route="initiatives/preview"
      params={params}
      scroll={false}
      {...props}
    />
  );
};

export const NewInitiativeLink = ({ projectId, initiativeType, ...props }) => (
  <AuthorizedAction action="create" subject={`${initiativeType}Initiative`}>
    <Link
      route="initiatives/new"
      params={{
        projectId,
        initiativeType,
        slug: getOrgSlug(),
      }}
      {...props}
    />
  </AuthorizedAction>
);

export const EditInitiativeLink = ({ initiative, ...props }) => (
  <AuthorizedAction action="update" subject={`${initiative.type}Initiative`}>
    <Link
      route="initiatives/edit"
      params={{
        initiativeId: initiative.id,
        initiativeType: initiative.type,
        slug: getOrgSlug(),
      }}
      {...props}
    />
  </AuthorizedAction>
);

export const InitiativeFilesLink = ({ initiative, ...props }) => (
  <AuthorizedAction action="read" subject="linkedFile">
    <Link
      route="initiatives/files"
      params={{
        initiativeId: initiative.id,
        initiativeType: initiative.type,
        slug: getOrgSlug(),
      }}
      {...props}
    />
  </AuthorizedAction>
);
